export default {
    'required_field': 'Please fill in this required field.',
    'incorrect_url' : 'Incorrect URL.',
    'invalid_value' : 'Invalid value.',
    'invalid_option': "You've already used the option '{option}'"
}